var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.167,20.334H18.833c-0.829,0-1.5,0.672-1.5,1.5v56.332c0,0.828,0.671,1.5,1.5,1.5h62.333c0.829,0,1.5-0.672,1.5-1.5   V21.834C82.667,21.006,81.995,20.334,81.167,20.334z M20.333,23.334H48.5v53.332H20.333V23.334z M79.667,76.666H51.5V23.334h28.166   V76.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.151,37.868c0.324-0.458,0.367-1.059,0.109-1.557c-0.257-0.498-0.771-0.812-1.333-0.812H25.905   c-0.561,0-1.075,0.313-1.333,0.812c-0.258,0.498-0.215,1.099,0.109,1.557l8.236,11.611v12.228h-3.5c-0.829,0-1.5,0.672-1.5,1.5   s0.671,1.5,1.5,1.5H39.75c0.829,0,1.5-0.672,1.5-1.5s-0.671-1.5-1.5-1.5h-3.833V49.478L44.151,37.868z M40.025,38.5l-5.608,7.907   L28.808,38.5H40.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.833,41.625h10c0.829,0,1.5-0.672,1.5-1.5s-0.671-1.5-1.5-1.5h-10c-0.829,0-1.5,0.672-1.5,1.5   S59.005,41.625,59.833,41.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.833,51.125h10c0.829,0,1.5-0.672,1.5-1.5s-0.671-1.5-1.5-1.5h-10c-0.829,0-1.5,0.672-1.5,1.5   S59.005,51.125,59.833,51.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.833,57.625h-10c-0.829,0-1.5,0.672-1.5,1.5s0.671,1.5,1.5,1.5h10c0.829,0,1.5-0.672,1.5-1.5   S70.662,57.625,69.833,57.625z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarte);
export default __webpack_public_path__ + "static/media/carte.256ba6fd6471b22d299caa94b318ca62.svg";
export { ForwardRef as ReactComponent };